const Resources = () => {
  return (
    <section className="resources content-section">
      <div>
        <h2>Additional Resources</h2>
        <ul>
          <li><a href="https://www.cancer.gov/publications/dictionaries/cancer-terms/def/steroid">Definition of steroids</a> (National Cancer Institute)</li>
          <li><a href="https://harmreduction.org/about-us/principles-of-harm-reduction/">Principles of harm reduction</a> (National Harm Reduction Coalition)</li>
          <li><a href="https://www.sfaf.org/resource-library/what-is-harm-reduction/">What is harm reduction?</a> (San Francisco AIDS Foundation)</li>
          <li><a href="https://lgbtqhealthcaredirectory.org/">Find an LGBTQ+ friendly healthcare provider near you</a></li>
        </ul>
      </div>
      <div>
        <h2>References</h2>
        <ol>
          <li id="ref1">
            Bonnecaze (2020)
          </li>
          <li id="ref2">
            Bolding (1999)
          </li>
          <li id="ref3">
            Griffiths (2017)
          </li>
          <li id="ref4">
            Blashill (2014)
          </li>
          <li id="ref5">
            Rabkin et al. (2000)
          </li>
          <li id="ref6">
            Halkitis (2008)
          </li>
          <li id="ref7">
            Yelland (2003)
          </li>
        </ol>
      </div>
    </section>
  )
}

export default Resources;